import '../scss/accordion.scss';

console.log('Accordion JS loaded');

document.addEventListener('DOMContentLoaded', () => {
    const accordionHeaders = document.querySelectorAll('.accordion-header');

    accordionHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const target = document.querySelector(header.dataset.target);

            if (target) {
                const isOpen = target.getAttribute('aria-hidden') === 'false';
                
                // Close all accordion bodies and remove 'active' class
                document.querySelectorAll('.accordion-body').forEach(body => {
                    body.setAttribute('aria-hidden', 'true');
                    body.style.maxHeight = null; // Reset maxHeight for all bodies
                    body.classList.remove('active'); // Remove 'active' class when closing
                });

                if (!isOpen) {
                    // Open the clicked accordion body and add 'active' class
                    target.setAttribute('aria-hidden', 'false');
                    target.style.maxHeight = `${ target.scrollHeight  + 48 }` + 'px'; // Set maxHeight to the content height for smooth transition
                    target.classList.add('active'); // Add 'active' class when opening
                }
            }
        });
    });
});
